module.exports = __webpack_public_path__ + "static/media/l12_voice_eleven_v2.784b681c.mp3";